module.exports = __webpack_public_path__ + "static/media/fMINUTA CANC. AFECTACION (ELLOS).a6bb2f96.pdf";